import HelpIcon from '@mui/icons-material/Help'
import { IconButton, Menu, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

export default function HelpBox({ showInsightVersion }: { showInsightVersion: boolean }) {
    const [anchorHelp, setAnchorHelp] = useState<null | HTMLElement>(null)
    const openHelp = Boolean(anchorHelp)

    const handleClickHelp = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorHelp(event.currentTarget)
    }

    const handleCloseHelp = () => {
        setAnchorHelp(null)
    }

    return (
        <>
            <IconButton size="small" onClick={handleClickHelp}>
                <HelpIcon />
            </IconButton>

            <Menu
                anchorEl={anchorHelp}
                open={openHelp}
                onClose={handleCloseHelp}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{ sx: { width: 850, overflow: 'hidden', pr: 2 } }}
            >
                <VersionFrames showInsightVersion={showInsightVersion} />
            </Menu>
        </>
    )
}

function VersionFrames({ showInsightVersion }: { showInsightVersion: boolean }) {
    const [isAvailable, setIsAvailable] = useState<boolean | null>(null)

    const versionUrl = showInsightVersion
        ? '/api/getAppVersion'
        : `/api/getAppVersion?wizardversion=${encodeURIComponent(process.env.REACT_APP_VERSION ?? 'unknown')}`

    useEffect(() => {
        const checkVersionEndpoint = async () => {
            setIsAvailable(null)

            const probeUrl = `${versionUrl}${versionUrl.includes('?') ? '&' : '?'}_=${Date.now()}`

            try {
                const response = await fetch(probeUrl, {
                    method: 'GET',
                    cache: 'no-store',
                })

                if (!response.ok) {
                    throw new Error(`Version endpoint returned ${response.status}`)
                }

                setIsAvailable(true)
            } catch {
                setIsAvailable(false)
            }
        }

        checkVersionEndpoint()
    }, [versionUrl])

    if (isAvailable === null) {
        return (
            <Stack direction="column" sx={{ p: '10px', width: '100%' }}>
                <Typography>
                    Checking connection...
                </Typography>
            </Stack>
        )
    }

    if (!isAvailable) {
        return (
            <Stack direction="column" sx={{ p: '10px', width: '100%' }}>
                <Typography sx={{ fontWeight: 'bold' }}>
                    The internet connection is not available.
                </Typography>
                <Typography>
                    Version information cannot be retrieved.
                </Typography>
            </Stack>
        )
    }

    return (
        <Stack direction="column" sx={{ p: '10px', width: '100%' }}>
            <iframe
                title={showInsightVersion ? 'VersionWithoutParam' : 'VersionWithParam'}
                src={versionUrl}
                style={{
                    width: '100%',
                    height: showInsightVersion ? 445 : 350,
                    border: 0,
                    display: 'block',
                }}
            />
        </Stack>
    )
}